import { render, staticRenderFns } from "./MultipleAutocompleteInput.vue?vue&type=template&id=b3d44f78&scoped=true"
import script from "./MultipleAutocompleteInput.vue?vue&type=script&lang=js"
export * from "./MultipleAutocompleteInput.vue?vue&type=script&lang=js"
import style0 from "./MultipleAutocompleteInput.vue?vue&type=style&index=0&id=b3d44f78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d44f78",
  null
  
)

export default component.exports